import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../commons/KpiChart';

const LearningCorrectAnswersRateGauge = (props) => (
  <KpiChart
    title="Correct answers rate"
    description="The number represents the average between each course correct answers rate. The calculate course correct answers rate is the comparing between the number of correct answers of the course Bonus Test and the previous Bonus Test (not necessarily the previous course Bonus Test)."
    intervals={[0, 3, 7, 20]}
    loading={props.loading}
    currentValue={props.value}
    formatter={props.formatter}
  />
);

LearningCorrectAnswersRateGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
  formatter: PropTypes.func.isRequired,
};

export default LearningCorrectAnswersRateGauge;
